import * as React from "react";
import * as PropTypes from "prop-types";
import styles from "./WidgetHeader.module.css";

const WidgetHeader = ({ title }) => (
  <header className={styles.header}>
    <h3 className={styles.widgetTitle}>{title}</h3>
  </header>
);

WidgetHeader.propTypes = {
  title: PropTypes.string.isRequired
};

export default WidgetHeader;
